module.exports = __webpack_public_path__ + "media/a2.c5cf8b85.mp3";